import React, {useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography, Divider, TextField, InputAdornment, DialogActions
} from '@mui/material';
import AddBox from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {EditOutlined} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import {useSnackbar} from "notistack";
import LoadingButton from "../../../components/elements/LoadingButton";
import validator from "validator";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useNavigate} from "react-router-dom";
import FieldCounter from "../../../components/elements/fields/FieldCounter";
import {updateRedux} from "../../../../config/Security";
import {useTranslation} from "react-i18next";
import SubTitle from "../../../components/elements/SubTitle";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import RayaField from "../../../components/elements/fields/RayaField";
import {Pencil} from "lucide-react";

const MakeCategoryButton = ({ disabled, classes,item_id,industry_id,parent_id,reload }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();

    const initFields = {
        name: '',
        description: '',
    };
    const [fields, setFields] = useState(initFields);
    const [errors, setErrors] = useState({});
    const [file, setFile] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const loadData = async () =>{
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        }
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/categories/get/${item_id}`,config)
            .then(response => {
                let fields = {
                    name: response.data.name,
                    description: !!response.data.description ? response.data.description : "",
                }
                setFile(response.data.file);
                setFields(fields);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                navigation('/');
                setLoading(false); // Set loading to false even if there is an error
            });
    }

    useEffect(() => {
        if(!!item_id && !!open)  loadData();
    }, [item_id,open]);
    useEffect(() => {

    }, [industry_id,parent_id]);
    
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleField = (input,val) => {
        setFields((prevFields) => ({ ...prevFields, [input] : val }));
        setErrors((prevErrors) => ({ ...prevErrors, [input]: '' }));

    };
    const resetFields = () => {
        setFields(initFields);
        setFile(null);
    }
    const closeDialog = () => {
        setOpen(false);
        if(!item_id){
            setTimeout(() => {
                resetFields();
            }, 300);
        }

    }
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            newErrors.name = t('emptyField');
        }
        if(!!fields.description){
            if(fields.description.length > 1000){
                formIsValid = false;
                newErrors.description = t('maxLength1000');
            }
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('name', fields.name);
        data.append('description', fields.description);
        if(!!file){
            data.append('file_id', file.id);
        }
        if(!!item_id){
            data.append('item_id', item_id);
        }
        if(!!industry_id){
            data.append('industry_id', industry_id);
        }
        if(!!parent_id){
            data.append('parent_id', parent_id);
        }

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/categories/make`, data, config);
            reload();
            setSubmitLoading(false);
            closeDialog();
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateItemName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    return (
        <>
            {
                !!parent_id ?
                    <Button
                        disabled={disabled}
                        color="secondary"
                        startIcon={<AddBox/>}
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {t('addChildCategory')}
                    </Button>
                    :
                !item_id ?
                    <Button
                        disabled={disabled}
                        variant={!!item_id ? "contained" : "contained"}
                        color="secondary"
                        startIcon={!!item_id ? <Pencil className="lucide-icon-secondary btn"/> : <AddBox/>}

                        onClick={() => setOpen(!open)}
                        //className={!!item_id ? "editItemBtn" : "addItemBtn"}
                    >
                        {t(!!item_id ? "editCategory" : 'addCategory')}
                    </Button>
                    :
                    <Button
                        disabled={disabled}
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpen(!open)}
                        startIcon={!!item_id ? <Pencil className="lucide-icon-secondary btn"/> : <AddBox/>}
                    >
                        {t(!!item_id ? "edit" : 'addCategory')}
                    </Button>
             }


            <Dialog
                fullWidth
                maxWidth={'sm'}
                open={open}
                onClose={() => closeDialog()}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    {t(!!item_id ? "editCategory" : 'addCategory')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={() => closeDialog()}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={2}>
                        {
                            !!loading ?
                                <Grid item size={12}>
                                    <AppCardLoaderFields height={300}/>
                                </Grid>
                                    :
                                <>
                                    <Grid item size={12} className="imageChooserHolder">
                                        <SingleImageChooser
                                            primary
                                            onChange={(file) => setFile(file)}
                                            initial={file}
                                            width={150}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('categoryName')}
                                            name="name"
                                            value={fields.name}
                                            onChange={handleChange}
                                            error={!!errors.name}
                                            helperText={errors.name}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            multiline
                                            fullWidth
                                            name="description"
                                            label={t('categoryDesc')}
                                            type="text"
                                            className={classes.inputCtl}
                                            rows="4"
                                            value={fields.description}
                                            onChange={handleChange}
                                            error={!!errors['description']}
                                            helperText={errors['description']}
                                            slotProps={{
                                                input: {
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <FieldCounter length={fields.description.length} max={1000}/>
                                                        </InputAdornment>
                                                    ),
                                                }
                                            }}
                                        />
                                    </Grid>
                                </>
                        }

                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex",justifyContent:"center"}}>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {t('setDetails')}
                        </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(MakeCategoryButton);
